module.exports = __webpack_public_path__ + "img/icon-coupon-gray.9f81f6e4.svg";